import { AccessorsMutatorsDecorator, Model } from "../../helpers";

export class GuestNote extends Model {
    
}

AccessorsMutatorsDecorator('id', 'user', 'guest', 'note', 'status', 'created_at', 'updated_at', 'property_id')(GuestNote);


// WEBPACK FOOTER //
// ./src/pms-api/models/guest-note.model.js